export default __webpack_public_path__ + "static/media/filigree.df8f3479.png";